import { createAction } from 'redux-act';
// report-common
import { getReportActions } from '../../../report-common';
//////////////////////////////////////////////////

const {
  setReports,
  setUsedReport,
  setListLoading,
  setInitialState,
  setReportPending,
  deleteItemRequest,
  deleteItemSuccess,
  setTableTitleSort,
  getItemListRequest,
  getItemListSuccess,
  createReportRequest,
  updateReportRequest,
  setTableTitleFilter,
  setIgnorePromptStatus,
  resetListAndPagination,
  setInitialStateOmitReport,
  changeDefaultReportRequest,
} = getReportActions();

const toggleGeoFencingZoneDetails = createAction('toggleGeoFencingZoneDetails');
const createGeoFencingZoneExportRequest = createAction('createGeoFencingZoneExportRequest');
const createOrUpdateGeoFencingZoneRequest = createAction('createOrUpdateGeoFencingZoneRequest');
const getAvailableReportGeoFencingZoneListRequest = createAction('getAvailableReportGeoFencingZoneListRequest');
const getAvailableReportGeoFencingZoneListSuccess = createAction('getAvailableReportGeoFencingZoneListSuccess');

export {
  // report
  setReports,
  setUsedReport,
  setListLoading,
  setInitialState,
  setReportPending,
  deleteItemRequest,
  deleteItemSuccess,
  setTableTitleSort,
  getItemListRequest,
  getItemListSuccess,
  createReportRequest,
  updateReportRequest,
  setTableTitleFilter,
  setIgnorePromptStatus,
  resetListAndPagination,
  setInitialStateOmitReport,
  changeDefaultReportRequest,
  // report
  toggleGeoFencingZoneDetails,
  createGeoFencingZoneExportRequest,
  createOrUpdateGeoFencingZoneRequest,
  getAvailableReportGeoFencingZoneListRequest,
  getAvailableReportGeoFencingZoneListSuccess,
};
